<template>
  <div>
    <!-- 轮播图部分 -->
    <div class="swiper-container">
      <swiper
        :slidesPerView="1"
        :spaceBetween="0"
        :loop="true"
        :autoplay="{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }"
        :navigation="{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }"
        :modules="modules"
        class="mySwiper"
      >
        <swiper-slide v-for="(slide, i) in currentSlides" :key="i">
          <img :src="slide" :alt="`slide-${i+1}`" />
        </swiper-slide>
      </swiper>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>

    <div class="brand-logo-bar">
      <div class="brand-logo-list">
        <img
          class="brand-logo brand-logo--kabin"
          :src="brandLogos.kabin"
          alt="Cabbeen"
        />
        <a
          class="brand-logo-link"
          href="https://www.cabbeen.com/product/list/2/3.html"
          target="_blank"
          rel="noopener"
        >
          <img
            class="brand-logo"
            :src="brandLogos.twoAm"
            alt="2AM"
          />
        </a>
      </div>
    </div>

    <div class="star-show-section">
      <div class="star-show-title" v-html="$t('celebrityTitleHtml')"></div>
      <div class="star-show-list">
        <div class="star-show-item" v-for="(img, idx) in starImages" :key="idx">
          <img :src="img" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation } from "swiper/modules";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

const modules = [Autoplay, Navigation];

const pcSlides = [
  new URL('@/assets/images/cabbeen&2am image/home/2.jpg', import.meta.url).href,
  new URL('@/assets/images/cabbeen&2am image/home/1.jpg', import.meta.url).href,
  new URL('@/assets/images/cabbeen&2am image/home/3.jpg', import.meta.url).href,
  new URL('@/assets/images/cabbeen&2am image/home/4.jpg', import.meta.url).href,
];

const mobileSlides = [
  new URL('@/assets/images/cabbeen&2am image/home/phone/1.jpg', import.meta.url).href,
  new URL('@/assets/images/cabbeen&2am image/home/phone/2.jpg', import.meta.url).href,
  new URL('@/assets/images/cabbeen&2am image/home/phone/3.jpg', import.meta.url).href,
  new URL('@/assets/images/cabbeen&2am image/home/phone/4.jpg', import.meta.url).href,
];

const isMobile = ref(false);

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};

const currentSlides = computed(() => (isMobile.value ? mobileSlides : pcSlides));

onMounted(() => {
  checkMobile();
  window.addEventListener("resize", checkMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkMobile);
});

const brandLogos = {
  kabin: new URL('@/assets/images/logo/kabin.jpg', import.meta.url).href,
  twoAm: new URL('@/assets/images/logo/2AM.jpg', import.meta.url).href,
};

const starImages = [
  new URL('@/assets/images/明星1.jpg', import.meta.url).href,
  new URL('@/assets/images/明星2.jpg', import.meta.url).href,
  new URL('@/assets/images/明星3.jpg', import.meta.url).href,
  new URL('@/assets/images/明星4.jpg', import.meta.url).href,
];
</script>
<style scoped>
.swiper-container {
  position: relative;
  width: 100%;
  height: 100dvh;
  background: #000;
}
.mySwiper {
  width: 100%;
  height: 100%;
  background: #000;
}
.mySwiper img {
  width: 100%;
  height: 100%;
  display: block;
}
/* PC端：横向铺满且完整展示，无左右黑边 */
@media (min-width: 1025px) {
  .swiper-container { height: auto; }
  .mySwiper { height: auto; }
  .mySwiper img {
    width: 100%;
    height: auto;
  }
  .mySwiper img {
    object-fit: unset;
  }
}

/* 移动端：保持原有裁剪效果 */
@media (max-width: 768px) {
  .mySwiper img {
    object-fit: cover; /* 移动端竖图裁剪填满 */
  }
}

/* 导航按钮 */
.swiper-button-next,
.swiper-button-prev {
  color: #f39c12;
  width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}
.swiper-button-next { right: 20px; }
.swiper-button-prev { left: 20px; }
.swiper-button-next::after,
.swiper-button-prev::after { font-size: 24px; }

.brand-logo-bar {
  background: #000;
  padding: 24px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.brand-logo-list {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.brand-logo-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
}

.brand-logo {
  display: block;
  height: 90px;
  width: auto;
  max-width: 220px;
  object-fit: contain;
  background: #000;
}

.brand-logo--kabin {
  height: 110px;
  max-width: 260px;
  transform: translateY(6px);
}

.star-show-section {
  background: #000;
  padding: 120px 0 40px 0;
  text-align: center;
}
.star-show-title {
  text-align: center;
  font-size: 1.7rem;
  font-weight: bold;
  margin-bottom: 100px;
  letter-spacing: 2px;
}
.star-show-title ::v-deep .zh { color: #fff; font-size: 1.5rem; }
.star-show-title ::v-deep .en { color: #ffb100; font-size: 1.5rem; margin-left: 0.3em; }
.star-show-list {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
}
.star-show-item {
  flex: 1 1 22%;
  max-width: 2000px;
  background: #000;
  overflow: hidden;
  box-shadow: none;
  transition: box-shadow 0.3s;
}
.star-show-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: #000;
  transition: transform 0.3s ease;
}
.star-show-item:hover img { transform: scale(1.1); z-index: 2; }

@media (max-width: 1024px) {
  .swiper-container { height: 70vh; }
  .star-show-list { gap: 20px; max-width: 90%; margin: 0 auto; }
  .star-show-item { flex: 0 0 calc(50% - 10px); max-width: calc(50% - 10px); }
}

/* 移动端：竖图更友好的纵横比和按钮尺寸 */
@media (max-width: 768px) {
  .swiper-container {
    height: auto;
    aspect-ratio: 9 / 16; /* 适配竖版图 */
  }
  .mySwiper { height: auto; aspect-ratio: 9 / 16; }
  .mySwiper img { height: auto; aspect-ratio: 9 / 16; }

  .swiper-button-prev,
  .swiper-button-next {
    width: 36px;
    height: 36px;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .swiper-button-prev::after,
  .swiper-button-next::after { font-size: 18px; }

  .star-show-section { padding: 60px 0 20px 0; }
  .star-show-title { margin-bottom: 40px; }
  .star-show-list { gap: 20px; max-width: 95%; }
  .star-show-item { flex: 0 0 100%; max-width: 90%; margin: 0 auto; }

  .brand-logo-bar { padding: 20px 12px; }
  .brand-logo-list {
    width: 100%;
    gap: 8px;
    flex-wrap: nowrap;
  }
  .brand-logo-link {
    flex: 1 1 0;
    width: 50%;
    max-width: 50%;
  }
  .brand-logo {
    flex: 1 1 0;
    width: 100%;
    max-width: 100%;
    height: auto;
    max-height: 180px;
  }
  .brand-logo--kabin {
    flex: 1 1 0;
    width: 50%;
    height: auto;
    max-width: 50%;
    max-height: 210px;
    transform: none;
  }
}

@media (max-width: 480px) {
  .star-show-list { flex-direction: column; gap: 20px; }
  .star-show-item { flex-basis: 99%; max-width: 90%; }
  .star-show-title { font-size: 1.3rem; margin-bottom: 30px; }
  .star-show-title ::v-deep .zh,
  .star-show-title ::v-deep .en { font-size: 1.2rem; }

  .brand-logo-list { gap: 4px; }
  .brand-logo {
    max-height: 140px;
  }
  .brand-logo--kabin {
    max-height: 165px;
  }
}
</style>
